import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntercomDirective } from './intercom.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [IntercomDirective],
  exports: [IntercomDirective],
})
export class IntercomModule {}
